// element 하위의 모든 span 태그를 돌면서 callback을 실행하는 HOF
export function createSpanIterator(callback) {
  return node => {
    Array.prototype.forEach.call(node.querySelectorAll('span'), (spanElement) => {
      // data-mce-style attribute 를 제거하고 style로 옮긴다.
      spanElement.setAttribute('style', spanElement.getAttribute('data-mce-style') || spanElement.getAttribute('style'));
      spanElement.removeAttribute('data-mce-style');

      callback(spanElement);
    });
  }
}

export const removeLegacyEditorParagraphSizeStyles = createSpanIterator((spanElement) => {
  spanElement.style.removeProperty('font-size');
});

export const removeLegacyEditorParagraphFontFamilyStyles = createSpanIterator((spanElement) => {
  spanElement.style.removeProperty('font-family');
});

const convertLineThroughStyleToStrike = createSpanIterator(spanElement => {
  if (spanElement.style.textDecoration === 'line-through') {
    spanElement.style.textDecoration = '';
    spanElement.outerHTML = `<s>${spanElement.innerHTML}</s>`;
  }
});

function convertLineThroughToStrike(editor) {
  const $ = editor.dom.$;

  // ul > li element나
  // table의 td element는 p 없이 span 태그가 적용되어있는 경우가 있다.
  $('p, ul > li, td').each((index, paragraphElement) => {
    Array.prototype.forEach.call(paragraphElement.querySelectorAll('strike'),strikeElement => {
      strikeElement.outerHTML = `<s>${strikeElement.innerHTML}</s>`;
    });

    convertLineThroughStyleToStrike(paragraphElement);
  });
}

function convertMoreless(editor) {
  const $ = editor.dom.$;

  $('div.txc-moreless').each((index, moreLessContainer) => {
    const innerContainer = moreLessContainer.querySelector('div.txc-morecontents');

    // 일부 글의 경우 div-txc-morecontents 형태에 한단계 더 감싸져있는 경우가 있는것 같다.
    const contentHTML = innerContainer ? innerContainer.innerHTML : moreLessContainer.innerHTML;

    moreLessContainer.querySelector('div.txc-morecontents')
    moreLessContainer.outerHTML = `<div data-ke-type="moreLess" data-text-more="더보기" data-text-less="닫기">
${contentHTML}
</div>`
  });
}

function convertHorizontalRule(editor) {
  const $ = editor.dom.$;

  $('hr').each((index, hrElement) => {
    const parent = hrElement.parentElement;

    if (hrElement.getAttribute('data-ke-type') === 'horizontalRule') {
      return;
    }

    // 구에디터에서 div로 감싸서 특수이미지로 데코레이션 되어있는 hr 대응
    if (parent && parent.tagName.toLowerCase() === 'div'
      && parent.style.background && parent.style.background.includes('/horizontalrule')) {
      parent.outerHTML = `<hr data-ke-type="horizontalRule" data-ke-style="style5" contenteditable="false">`
    } else {
      hrElement.setAttribute('data-ke-type', 'horizontalRule');
      hrElement.setAttribute('data-ke-style', 'style5'); // todo: css style 파싱해서 적절한 스타일로 변환..? 현실적으로 불가능해 보임
      hrElement.setAttribute('contenteditable', 'false');
    }
  });
}

function findParentTag(node, tagName, maxDepth = 2) {
  let depth = 0;

  while (node.parentElement && depth < maxDepth) {
    node = node.parentElement;
    if (node.tagName.toLowerCase() === tagName.toLowerCase()) {
      return node;
    }

    // figure node가 너무 멀리있는 parent 인지 체크해야한다. 안그러면 본문의 많은 부분이 날아갈 가능성.
    depth++;
  }

  return null;
}

// ke 에서 지원되지 않는 형태의 figure img 를 컨버팅한다
// 대상 ex) 언론사 기사 복붙한 글.. 등..
function convertFiguredImage(editor) {
  const $ = editor.dom.$;

  $('figure img').each((index, imageElement) => {
    const figureElement = findParentTag(imageElement, 'figure');

    if (figureElement === null) {
      return;
    }

    // ke item 으로 판단되면 스킵한다.
    if (figureElement.getAttribute('data-ke-type')) {
      return;
    }

    const anchorElement = findParentTag(imageElement, 'a');
    const figcaptionElement = figureElement.querySelector('figcaption');

    const imageSource = imageElement.getAttribute('src');
    const caption = figcaptionElement ? figcaptionElement.textContent : '';

    if (anchorElement) {
      const href = anchorElement.getAttribute('href');
      const target = anchorElement.getAttribute('target') || '_blank';

      figureElement.outerHTML = `<figure data-ke-type="image" data-ke-style="alignCenter" data-link="${href}" data-link-newwindow="${target}">
<a href="${href}" target="${target}"><img src="${imageSource}"/></a>
<figcaption>${caption}</figcaption>
</figure>`;
    } else {
      figureElement.outerHTML = `<figure data-ke-type="image" data-ke-style="alignCenter">
<img src="${imageSource}"/>
<figcaption>${caption}</figcaption>
</figure>`;
    }
  });
}

function removeFootnoteBox(editor) {
  const $ = editor.dom.$;
  $('div.txc-footnote-box').each((idx, element) => {
    element.remove();
  });
}

function convertFontTag(editor) {
  const $ = editor.dom.$;

  $('font[color]').each((idx, element) => {
    const color = element.getAttribute('color');
    element.outerHTML = `<span style="color: ${color}">${element.innerHTML}</span>`;
  });
}

const plugin = (editor) => {
  // 에디터에 컨텐츠 로딩 시점에 컨버팅
  // 1. 더보기: div html 형태가 너무 달라서 ke 상에서 표현이 안되므로 맞게 변환
  // 2. 취소선: 구에디터에서는 style=text-decoration: line-through 혹은 <strike> 태그로 표현되는데 <s> 태그로 변
  // 3. hr: hr 스타일이 구에디터에서는 css style로 들어가있는데 ke와는 호환이 안되므로 일괄적으로 style5로 변환
  // 4. figured image: ke 에서 지원되는 형태가 아닌 figure > img 형태를 ke 형태로 변환.
  // 5. footnote box: 구블로그의 각주 박스가 본문에 삽입되어있는데 이를 제거
  // 6. <font color> 형태의 옛날 HTML을 ke에 맞게 변환 ㅠ-ㅠ
  editor.on('SetContent', event => {
    convertMoreless(editor);
    convertLineThroughToStrike(editor);
    convertHorizontalRule(editor);
    // TIP-13327 외부 이미지 복사는 하지 않는다. (timeout 이슈)
    // convertFiguredImage(editor);
    removeFootnoteBox(editor);
    convertFontTag(editor);

    // 위 convert 과정이 끝난 이후에 강제로 에디터 change 이벤트를 발생시킨다.
    // 이를 통해 redux 의 콘텐트와 tinymce 내부의 콘텐츠를 동기화한다.

    // TIP-13737 이슈 때문에 일단 주석처리함.
    // 최초 로딩시 KE <-> HTML 모드간의 동기화 되면 안됨.
    // setTimeout(() => {
    //   editor.fire('change');
    // }, 0)
  });

  editor.on('init', () => {
    // formatChanged event 리스너를 등록해
    // 폰트 사이즈 변경 액션을 감지할수 있다.
    // 폰트 변경시 구에디터에서 설정된 폰트 사이즈는 초기화한다.
    editor.formatter.formatChanged('custom0,custom1,custom2,custom3,custom4,custom5,custom6,custom7,custom8,custom9,custom10', (toggledState, event) => {
      if (!toggledState) {
        return;
      }
      removeLegacyEditorParagraphSizeStyles(event.node);
    });
  });

  editor.on('BeforeExecCommand', event => {
    // 폰트 변경 전에 현재 selection 하위의 span에 있는 font-family style들 제거
    if (event.command === 'FontName') {
      removeLegacyEditorParagraphFontFamilyStyles(event.target.selection.getNode());
    }
  });
};

export default plugin;
